var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoOnlyCelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 50,
    viewBox: "0 0 90 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9435_11377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.015625 0.661331H89.2573V49.3387H0.015625V0.661331Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9435_11377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.715 16.7446C30.9514 11.2251 21.768 9.36824 17.2517 9.97042C14.7932 19.7557 20.4131 28.5871 24.1263 32.2503C27.8398 35.9137 33.8406 39.7248 41.1346 40.6899C34.3166 37.7411 30.2888 35.4409 25.6022 29.6186C20.5914 23.3948 19.1209 18.1945 20.2926 13.4346C26.371 13.2881 32.4992 17.0231 34.0118 19.4031C34.3899 17.4258 34.7144 16.7449 34.7144 16.7449",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.279 25.0571C18.279 25.0571 14.5927 22.1859 10.4676 24.2852C11.1997 27.8736 13.5432 29.6555 15.6182 30.2171C15.0566 30.5588 14.5687 30.3879 13.2993 30.9249C9.46677 28.8256 8.12419 25.4286 8.14852 22.8917C11.9808 20.892 15.8136 21.4292 17.3025 22.7228C17.6857 24.0471 18.279 25.0571 18.279 25.0571Z",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7969 33.7809C24.7969 33.7809 22.9417 32.1696 21.9898 30.9246C19.3043 29.9483 15.0081 30.7783 12.8845 31.6573C10.7606 32.5359 8.173 33.6344 4.07227 32.9266C4.84101 37.7411 11.2855 44.9975 24.211 44.9975C35.2691 44.9975 40.5052 41.1163 40.5052 41.1163C40.5052 41.1163 37.0633 43.2766 28.7147 43.2766C20.3662 43.2766 12.6404 39.9446 8.86876 35.8067C12.5671 36.0267 11.9077 34.0494 16.6495 33.2806C21.3916 32.5116 24.7969 33.7809 24.7969 33.7809Z",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0482 11.3253C46.6567 12.5923 51.6842 18.8207 51.6842 26.5811C51.6842 31.5817 51.0362 36.616 46.7709 40.7809C50.5345 38.7737 54.7717 32.8524 54.7717 25.0568C54.7717 12.896 44.0482 5.00247 44.0482 5.00247C44.0482 5.00247 34.0122 12.896 34.0122 25.0568C34.0122 32.8524 38.6791 38.7737 42.4426 40.7809C38.1771 36.616 36.5714 30.0577 36.5714 25.0568C36.5714 17.2967 43.0445 11.827 44.0482 11.3253Z",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1548 16.7446C57.9183 11.2248 67.1012 9.36824 71.6175 9.97041C74.0763 19.7557 68.4561 28.5871 64.7429 32.2503C61.0294 35.9137 55.0285 39.8106 47.7346 40.7757C55.5225 37.3006 59.1791 34.7817 63.2672 29.6186C68.2274 23.3545 69.7483 18.1945 68.5766 13.4343C62.4982 13.2878 56.3703 17.0228 54.8574 19.4028C54.4796 17.4255 54.1548 16.7446 54.1548 16.7446Z",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7256 24.835C70.7256 24.835 74.4119 21.9638 78.537 24.0631C77.8048 27.6515 75.4614 29.4334 73.3864 29.995C73.948 30.3367 74.4359 30.1658 75.7053 30.7028C79.5378 28.6034 80.8804 25.2065 80.8561 22.6696C77.0238 20.6699 73.1915 21.2071 71.7021 22.5007C71.3189 23.825 70.7256 24.835 70.7256 24.835Z",
    fill: "#0E2F76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3903 33.6092C64.3903 33.6092 66.2455 31.9978 67.1979 30.7528C69.8828 29.7763 74.179 30.6063 76.3027 31.4855C78.4266 32.3642 81.1 33.5482 85.2011 32.8404C84.1278 37.6552 77.9017 44.8255 64.9761 44.8255C54.3465 44.8255 48.7678 41.1163 48.7678 41.1163C48.7678 41.1163 53.1668 43.1046 60.4724 43.1046C68.821 43.1046 76.0963 39.505 80.0605 35.7208C76.2059 35.404 75.9864 33.5731 72.5377 33.1086C67.7767 32.4669 64.3903 33.6092 64.3903 33.6092Z",
    fill: "#0E2F76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyCelt);
export default __webpack_public_path__ + "static/media/logo_only_celt.e58b6e09704219950408686348901402.svg";
export { ForwardRef as ReactComponent };